import React from 'react';

function Navbar() {
    return (
        <nav className="flex items-center justify-between flex-wrap bg-red-600 p-6">
            <div className="flex items-center flex-shrink-0 text-white mr-6">
                <span className="font-semibold text-xl tracking-tight">Pokeapp</span>
            </div>
        </nav>
    );
}

export default Navbar;
